export default function CasesHero() {
  return (
    <section className="relative pt-40 pb-24 bg-[#1a1a1a] overflow-hidden">
      <div className="absolute inset-0 z-0 opacity-15">
        <img
          src="https://readdy.ai/api/search-image?query=collage%20commercial%20interior%20design%20spaces%20restaurant%20retail%20office%20clinic%20showroom%20portfolio%20dark%20background%20professional%20photography&width=1920&height=700&seq=caseshero001&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="relative z-10 max-w-[1440px] mx-auto px-6 md:px-10">
        <div className="max-w-3xl">
          <div className="flex items-center gap-3 mb-8">
            <div className="w-10 h-px bg-[#b8956a]"></div>
            <span className="text-[#b8956a] text-sm font-medium tracking-[0.2em] uppercase">Case Studies</span>
          </div>
          <h1
            className="text-white font-bold leading-[1.25] mb-6"
            style={{ fontSize: 'clamp(2rem, 4vw, 2.75rem)' }}
          >
            作品案例
          </h1>
          <p
            className="text-white/65 leading-[1.75] max-w-2xl"
            style={{ fontSize: '1.1875rem' }}
          >
            每個案例背後，都是一段深度的品牌空間策略實踐歷程。
            從需求分析到完工交付，我們記錄下每個空間的蛻變過程。
          </p>
        </div>
      </div>
    </section>
  );
}
